<template lang="pug">
  .activity-linked
    .row
      .col
        .activity-avatar
          UserAvatar(:user="activity.user")
      .col.max
        .activity-header
          .row.apart
            .col
              span.creator {{ activity.user.fullName }} {{ (activity.type === 'linked' ? 'merged in' : 'un-merged')}} a post
            .col
              span.created {{ activity.created | moment("from") }}

        router-link.activity-body(:to="{ name: routeName, params: { boardSlug: board.slug, featureSlug: selected.slug } }")
          .feature
            .row.apart
              .col.max
                .row.apart.center.feature-title
                  .col
                    h3 {{ selected.name }}

                .feature-body(v-html="descriptionFormatted")

                .feature-attachments(v-if="selected.attachments")
                  a.feature-attachment(
                    v-for="attachment in selected.attachments",
                    @click.stop,
                    :href="attachment.url",
                    target="_blank"
                  )
                    img(:src="attachment.url")

              .col.feature-comments
                font-awesome-icon.feature-comments-icon(:icon="['fad', 'comments']")
                span {{ selected.stats.comments }}

</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'ActivityLinked',
  props: {
    activity: Object
  },
  data () {
    return {
      selected: (this.activity.type === 'linked') ? this.activity.linkedFeature : this.activity.linkedFeatureWas
    }
  },
  mounted () {
    //console.log(this.activity)
  },
  computed: {
    ...mapGetters({
      board: 'boards/selected',
    }),
    descriptionFormatted () {
      return this.selected.description ? this.selected.description.replace(/\n/g, '<br/>') : ''
    },
    routeName () {
      return this.$route.meta.member ? 'AdminFeature' : 'PublicFeature'
    }
  }
}
</script>

<style scoped lang="stylus">
  .activity-linked
    border-bottom $border-default
    display block
    margin-bottom $spacing
    padding $spacing-4 0

    .activity-header
      color $text-light

    .creator
      font-size $text-size-small
      line-height $text-size-default
    .created
      font-size $text-size-smaller
      line-height $text-size-default

    .activity-avatar
      width 50px

    .activity-body
      border $border-default
      display block
      padding $spacing-2
      margin-top $spacing-2
      .feature
        //border-bottom $border-default
        display block
        //margin-bottom $spacing-2
        //padding $spacing 0

        //h3
        //  color $color-primary

        .feature-title
          margin-bottom 15px
          .col
            h3
              font-size 22px
              line-height 26px
              +for_breakpoint(mobile)
                font-size 18px

        .feature-status
          margin-bottom $spacing
          margin-top -5px
        //.feature-description
        //  padding 1rem 0

        .feature-body
          color $text-light
          line-height 22px
          //margin-bottom $spacing-4
          //padding $spacing 0

        .feature-footer
          color $text-light
          margin-bottom 10px

          .feature-footer-avatar
            width 50px

          .creator
            font-size $text-size-small
            line-height $text-size-default
            span
              margin-right 5px
            .icon
              margin-left 5px
          .created
            font-size $text-size-smaller
            line-height $text-size-default

          span
            display inline-block
            margin-right $spacing
</style>
